
class Animator {
    constructor(delay, onadvancetime, ondtchange) {
        this.ondtchange = ondtchange;
        this.onadvancetime = onadvancetime;
        this.anim_delay = delay;

        this.anim_timer = null;
    }

    isAnimating() {
        return this.anim_timer !== null;
    }

    toggleAnimation(turn_on_anim) {
        const do_animation = () => {
            const kill_timer = this.onadvancetime();

            if (!kill_timer) {
                this.anim_timer = window.setTimeout(do_animation, this.anim_delay);
            }
        }

        if (turn_on_anim && this.isAnimating() || !turn_on_anim && !this.isAnimating()) {
            return;
        }

        if (turn_on_anim) {
            this.anim_timer = window.setTimeout(do_animation, this.anim_delay);
        }
        else {
            window.clearTimeout(this.anim_timer);
            this.anim_timer = null;
        }
    }

    advanceTime(direction, cur_dt, dts) {
        let dt;
        const dts_sorted = [...dts].sort((a, b) => a.toMillis() - b.toMillis());
        let idx = dts_sorted.map(d => d.toMillis()).indexOf(cur_dt.toMillis());

        if (idx == -1) {
            if (direction > 0) {
                dt = dts_sorted[0];
            }
            else {
                dt = dts_sorted[dts.length - 1];
            }
        }
        else {
            if (direction > 0) {
                idx++
                if (idx >= dts.length) {
                    idx = 0;
                }
            }
            else {
                idx--
                if (idx < 0) {
                    idx = dts.length - 1;
                }
            }
            dt = dts_sorted[idx];
        }

        return this.ondtchange(dt);
    }
}

export default Animator;